import * as React from 'react';
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import { tokens } from '../../Components/DashboardTheme/DashboardTheme';
import SectionHeading from '../../Components/SectionHeading/SectionHeading';
import Reveal from '../../Components/Reveal/Reveal';
import ringImg from '../../img/ring-gruppo.webp';

export default function RingSide() {
    const theme = useTheme();
    const isScreenSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    return (
        <Box component="section" id="ringSideSection" sx={{ backgroundColor: tokens.ink }}>
            <SectionHeading
                kicker="Forti e fieri"
                title="RING SIDE"
                ghost="FIGHTERS"
                lead="Titoli, trasferte e notti sul ring. La storia del team, combattimento dopo combattimento."
            />

            <Reveal>
                <Box
                    onClick={() => navigate('/fightsHistoryPage')}
                    sx={{
                        position: 'relative',
                        height: { xs: '58vh', md: '80vh' },
                        overflow: 'hidden',
                        cursor: 'pointer',
                        mx: { xs: 2, md: 6 },
                        mb: { xs: 6, md: 10 },
                        ':hover img': { transform: 'scale(1.07)' },
                        ':hover .vg-ring-cta': { gap: '18px' },
                    }}
                >
                    <Box
                        component="img"
                        src={ringImg}
                        alt="Il team a bordo ring"
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            filter: 'grayscale(40%) brightness(0.45) contrast(1.1)',
                            transition: `transform 1.2s ${tokens.ease}`,
                        }}
                    />
                    <Box
                        aria-hidden
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            background: `linear-gradient(180deg, transparent 40%, ${tokens.ink}E6 100%)`,
                        }}
                    />
                    <Box
                        aria-hidden
                        sx={{
                            position: 'absolute',
                            inset: { xs: 12, md: 20 },
                            border: '1px solid rgba(255,255,255,0.16)',
                            pointerEvents: 'none',
                        }}
                    />

                    <Box sx={{ position: 'absolute', left: { xs: 24, md: 48 }, right: { xs: 24, md: 48 }, bottom: { xs: 28, md: 48 } }}>
                        <Box
                            sx={{
                                fontFamily: tokens.display,
                                fontSize: { xs: 34, md: 62 },
                                lineHeight: 1,
                                color: tokens.white,
                                mb: 2,
                            }}
                        >
                            FORTI E FIERI
                        </Box>
                        <Button
                            className="vg-ring-cta"
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                                color: tokens.white,
                                borderBottom: `2px solid ${tokens.red}`,
                                borderRadius: 0,
                                px: 0,
                                py: 1,
                                gap: '8px',
                                fontSize: isScreenSmall ? 13 : 15,
                                transition: `all 0.4s ${tokens.ease}`,
                                ':hover': { backgroundColor: 'transparent', color: tokens.red },
                            }}
                        >
                            Storia del team
                        </Button>
                    </Box>
                </Box>
            </Reveal>
        </Box>
    );
}
